import axios from "axios";
const token = JSON.parse(localStorage.getItem("TOKEN"))
const timezone = JSON.parse(localStorage.getItem("TIMEZONE"))

axios.defaults.timeout = 30000;
axios.defaults.timeoutErrorMessage='timeout'
if(token){
    axios.defaults.headers.common["x-access-token"] = token;
}
if(timezone){
    axios.defaults.headers.common["timezone"] = timezone?.timezone;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Session(url = `${process.env.REACT_APP_BASE_URL}/api/`) {
        return {
            getAvalableHost: (data, demoToken) => {
                if (demoToken) {
                    axios.defaults.headers.common["x-access-token"] = demoToken;
                    return(
                    axios.post(url + "session/blockHost", data))
                }
                else {
                    return(axios.post(url + "session/blockHost", data))
                }
            },
            createSession: (data, demoToken) =>{

                // console.log("sessionapi token")
                // console.log(demoToken);
                if(demoToken){
                    // console.log("demotoken condition passed")
                    axios.defaults.headers.common["x-access-token"] = demoToken;
                    return(
                    axios.post(url + "session/createnew", data))
                }
                else{
                    console.log("token condition passed")
                    return( axios.post(url + "session/createnew", data))
                }
            } ,
            studentUpcomingSession: (data) => axios.post(url + "session/fetchupcomingstudentsessionnew", data),
            studentPastSession: (data) => axios.post(url + "session/fetchpaststudentsessionnew", data),
            teacherFeedback: (data) => axios.put(url + "session/teacherfeedback", data),
            availableTeacher: (data) => axios.post(url + "schedule/getTeacherNew", data),
            getRandomTeacherForDemo: (data, demoToken) =>{

                // console.log(demoToken)
                if(demoToken){
                    axios.defaults.headers.common["x-access-token"] = demoToken;
                    return(                        
                        axios.post(url + "teacher/getRandomTeacherForDemo", data)
                    )
                }
                else{
                    return(axios.post(url + "teacher/getRandomTeacherForDemo", data))
                }
            } ,
            
            getAvailableSlot:(data) => axios.post(url + "teacher/getAvailableSlots", data),
            isPaymentDone: (data) => axios.put(url + "session/updatetDemoPayment", data),
            sessionDocs: (data) => axios.post(url + "learner/findLearnerNoteByCount", data),
            sessionCancelled: (data) => axios.post(url + "session/cancel", data),
            isTrialTakenOrNot: (data) => axios.post(url + "learner/isTrialaken", data),
            learnerSessionAttendance: (data) => axios.post(url + "session/updateLearnerJoiningTime", data),
            mostUsedTimeSlot: (data) => axios.post(url + "schedule/mostUsedTimeSlot", data),
            addRating:(data) => axios.post(url + "rating/addRating", data),
            getRating:(data) => axios.post(url + "rating/getRating", data),
            youtubeApproval:(data) => axios.post(url + "ytApproval/requestApproval", data),
            addKids: (data, demoToken) => {
                if (demoToken) {
                  axios.defaults.headers.common["x-access-token"] = demoToken;
                  return (
                    axios.post(url + "learner/newKid", data)
                  )
                }
                else {
                  return (axios.post(url + "learner/newKid", data))
                }
              },
        }
    }
}